/* eslint-disable */
require('./arrow-return')
require('./eye')
require('./idalgo')
require('./key')


// WEBPACK FOOTER //
// ./src/components/icons/index.js